/* eslint-disable */
import React, {Component} from 'react';
import Aux      from '../../hoc/Aux';

import Classes from './OnlineSongManager.css'
import DeezerPlayer                                             from './DeezerPlayer';
import {ToastsContainer, ToastsStore, ToastsContainerPosition}  from 'react-toasts';
import logger                                                   from './../../logger';
import lang from '../../lang.json';
import ScrollText from 'react-scroll-text'

class OnlineSong extends Component {
    state = {
        autoplay : false,
        songid : 0,
        showskipbutton: true
    }

    stopPlayer = () => {
        this.props.triggerStopPlayerFromChild();
        this.setState({autoplay : false});
        logger.debug('[OnlineSongManager|stopPlayer] Player stopped');
        ToastsStore.success("Player Stopped!");
    }

    startPlayer = () => {
        this.props.playPlayerChildTrigger();
        this.setState({autoplay : true});
        this.setState({songid: this.props.song.id});
        ToastsStore.success("Player Started!");
        logger.debug('[OnlineSongManager|startPlayer] Player started on songid' + this.state.songid);
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
          this.setState(state, resolve)
        });
    }

    skipCurrentSong = () => {
        this.setState({ showskipbutton: false });
        this.props.skipfunction();
        const timer = setTimeout(() => {
           
            this.setState({ showskipbutton: true });
            logger.debug('[OnlineSongManager|skipCurrentSong] Song skipped');
          }, 1800);
          return () => clearTimeout(timer);
    }

    banSong = () => {
        ToastsStore.success("Coming soon!");
    }

    banUser = () => {
        ToastsStore.success("Coming soon!");
    }

    componentWillReceiveProps(nextProps) {
        this.setState({songid: nextProps.song.id});

        if( nextProps.songAutoplay !== this.state.autoplay ){
            this.setState({autoplay: nextProps.songAutoplay})
            logger.debug('[OnlineSongManager|componentWillReceiveProps] Change autoplay to:' + nextProps.songAutoplay);
        }
    }

    jsUcfirst = (string) => {
        if(string)
            return string.charAt(0).toUpperCase() + string.slice(1);
    }
    
    delay = ms => new Promise(res => setTimeout(res, ms));

    btnSkipClicked = () => {
      this.setState({ showskipbutton: false });
      this.delay(10000);
      this.setState({ showskipbutton: true });
    }

    getTopUSer = () => {
        this.props.filter
    }

    countSongPlayedtimes = () => {
        const toCount = this.props.history.filter((el) => el.id === this.props.song.id);
        return toCount.length;
    }

    render() {
        return(    
            <Aux>
                <br />
                <div className="row col-12">
                        <div className="col-2" data-tut="reactour_login_deezer">
                            <img className={Classes.ImgAlbum} src={this.props.song.cover} />
                            <DeezerPlayer
                                autoplay={this.state.autoplay}
                                songid={this.state.songid}/>
                        </div>
                        <div className="col-6" data-tut="reactour_atm_online">
                                <ScrollText
                                    speed={30}>
                                     {lang[this.props.language].pbscreen_osm_song_name}: {this.jsUcfirst(this.props.song.name)}
                                </ScrollText> 
                         
                                <ScrollText
                                        speed={30}>
                                       {lang[this.props.language].pbscreen_osm_song_album}: {this.jsUcfirst(this.props.song.album)}
                                    </ScrollText> 
                                    <ScrollText
                                        speed={30}>
                                       {lang[this.props.language].pbscreen_osm_song_artist}: {this.jsUcfirst(this.props.song.artist)}
                                    </ScrollText> 
                                    <ScrollText
                                        speed={30}>
                                       {lang[this.props.language].pbscreen_osm_song_genre}: {this.jsUcfirst(this.props.song.genre)}
                                    </ScrollText> 
                            <br/>
                            <div className="row col-12" data-tut="reactour_song_control">
                                <div className={`col-4 ${Classes.TxtCenter}`}>
                                    {
                                        this.state.autoplay ? (
                                            <i className={`${Classes.btnInactive} fas fa-stop`} onClick={this.stopPlayer} />
                                        ) : (
                                            <i className={`${Classes.btnActiveStop} fas fa-stop`} onClick={this.stopPlayer} />
                                        )
                                    }    
                                </div>
                                <div className={`col-4 ${Classes.TxtCenter}`}>
                                    {
                                        this.state.autoplay ? (
                                            <i className={`${Classes.btnActive} fas fa-play`} onClick={this.startPlayer} />
                                        ) : (
                                            <i className={`${Classes.btnInactive} fas fa-play`} onClick={this.startPlayer} />
                                        )
                                    }
                                </div>
                                <div className={`col-4 ${Classes.TxtCenter}`}>
                                    {
                                        this.state.showskipbutton ? (
                                            <i className={`${Classes.btnInactive} fas fa-forward`} onClick={this.skipCurrentSong} />
                                        ) : (
                                            ''
                                        )
                                    }
                                
                                </div>
                            </div>
                        </div>
                        <div className={`col ${Classes.CardInfoData}`}>
                            <p><i class="fas fa-info-circle"></i> Canzoni proposte ieri: {this.props.historyYesterday.length}</p>
                            <p><i class="fas fa-info-circle"></i> Canzoni proposte oggi: {this.props.historyToday.length}</p>
                            <p><i class="fas fa-info-circle"></i> Canzone online riprodotta {this.countSongPlayedtimes()} volta/e</p>
                        </div>
                </div>
                <br/>     
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
            </Aux>

        )
  }
}

export default OnlineSong;